module.exports = __webpack_public_path__ + "static/media/instagram-rond.28eb3c0e.png";